// extracted by mini-css-extract-plugin
export default {"header":"Header_header__kasgQ","landing-image":"Header_landing-image__8IyO+"};